import { render, staticRenderFns } from "./voiceUser.vue?vue&type=template&id=70a5fd29&scoped=true&"
import script from "./voiceUser.vue?vue&type=script&lang=js&"
export * from "./voiceUser.vue?vue&type=script&lang=js&"
import style0 from "./voiceUser.vue?vue&type=style&index=0&id=70a5fd29&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a5fd29",
  null
  
)

export default component.exports